import { useSelector } from "react-redux";
import { RootState } from "../store/store";

type DataShownMappings = Record<string, string>;

interface CategoryData {
  dataShownMappings?: DataShownMappings;
}

type SectorData = Record<string, CategoryData>;
type FilterData = Record<string, SectorData>;

interface SectionTable {
  defaultDataShown: Record<string, string[]>;
  lagDropdown: boolean;
}

interface Sections {
  [key: string]: {
    enabled: boolean;
    table: SectionTable;
  };
}

export const DynamicMappings = () => {
  const userData = useSelector((state: RootState) => state.user);

  // --- Utility -------------------------------------------------------

  const normalizeCategoryKey = (key: string): string =>
    key
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/^salesgeo$/, "salesGeo")
      .replace(/^location$/, "location")
      .replace(/^pfe$/, "pfe")
      .replace(/^item$/, "items")
      .replace(/^customer$/, "customer");

  // --- Core Mapper ---------------------------------------------------

  function getCategoryMappingBySector(
    sector: string,
    filterData: FilterData,
    defaultSector: string
  ): Record<string, DataShownMappings> {
    const key = sector || defaultSector;
    const sectorBlock = filterData && filterData[key];
    if (!sectorBlock) {
      return {};
    }

    return Object.entries(sectorBlock).reduce((acc, [catName, catData]) => {
      acc[normalizeCategoryKey(catName)] = catData.dataShownMappings ?? {};
      return acc;
    }, {} as Record<string, DataShownMappings>);
  }

  const filterData = userData?.filterData as FilterData;
  const defaultSector = userData?.userSectorData?.defaultSector!;
  const selectedSector = userData?.currentSector?.sector ?? defaultSector;
  const categoryMap = getCategoryMappingBySector(
    selectedSector!,
    filterData,
    defaultSector!
  );
  return categoryMap;
};
